import { createSelector } from 'reselect'
import { DriverStatusType, IDriverState } from 'apps/fleet-planner/types'
import { IStore } from 'apps/fleet-planner/utils/types/store'

const driversStateSelector = (state: IStore): IDriverState => state.drivers

export const selectDrivers = createSelector(driversStateSelector, ({ drivers }) => drivers)
export const selectActiveDrivers = createSelector(selectDrivers, drivers =>
  drivers.filter(d => d.status === DriverStatusType.active)
)
export const selectDriversId = createSelector(selectDrivers, drivers => drivers.map(d => d.id))
export const selectDriversAutocompleteList = createSelector(
  driversStateSelector,
  ({ driversAutocomplete }) => driversAutocomplete
)
